import { useState, useEffect, ChangeEvent } from 'react';
import EmailInput from '../../../components/Inputs/EmailInput';
import StyledButton from '../../../components/Button/Button';
import { Box, Container, FormControl, Typography } from '@mui/material';
import { inviteBabysitter } from '../../../services/NetworkServices';
import { useNavigate } from 'react-router-dom';
import Popup from '../../../components/Inputs/Popup';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import TopNav from '../../../components/TopNav/TopNav';
import './InviteBabysitter.css';
import ApiStatus from '../../../config/apiStatusConstants';
import CircularProgress from '@mui/material/CircularProgress';
import { getStage } from '../../../services/NetworkServices';
import { storeStageNumber } from '../../../utils/auth-token-utils/cookie';

const InviteBabysitter: React.FC = () => {
  const [apiStatus, setApiStatus] = useState<ApiStatus>(ApiStatus.INITIAL);
  const [email, setEmail] = useState<string>('');
  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [errorMsg, setErrorMsg] = useState<string>('');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchStageDetails = async () => {
      try {
        console.log('inside use effect');
        const response = await getStage();
        const data = await response.data;
        if (data) {
          console.log('stage is', data.data.stage);
          const stage = data.data.stage;
          storeStageNumber(stage);
          if (stage === '1') {
            navigate('/participant/createProfile');
          }
          if (stage === '3') {
            navigate('/participant/selectplan');
          }
          if (stage === '4') {
            navigate('/participant/dashboard');
          }
        }
      } catch (error) {
        console.error('Error fetching profile details:', error);
      }
    };
    fetchStageDetails();
  }, [navigate]);

  const handleEmail = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleContinue = () => {
    navigate('/participant/selectplan');
  };

  const handleInvite = async () => {
    try {
      setApiStatus(ApiStatus.LOADING);
      const response = await inviteBabysitter({ email });
      console.log('response is', response);
      const data = await response.data;
      if (data) {
        setApiStatus(ApiStatus.SUCCESS);
        setErrorMsg('');
        setShowPopup(true);
      }
    } catch (error: any) {
      setApiStatus(ApiStatus.FAILURE);
      console.log('error is ', error);
      setErrorMsg(
        error.response.data.message ||
          'Something went wrong. Please try again.',
      );
    }
  };

  const renderButton = () => {
    if (apiStatus === ApiStatus.LOADING) {
      return (
        <StyledButton>
          <CircularProgress size={20} />
        </StyledButton>
      );
    } else {
      return (
        <StyledButton onClick={handleInvite} disabled={!email}>
          Connect
        </StyledButton>
      );
    }
  };

  const renderErrorMsg = () => {
    console.log('error is', errorMsg);
    if (apiStatus === ApiStatus.FAILURE) {
      return <p style={{ color: 'red', alignSelf: 'left' }}>{errorMsg}</p>;
    }
    return null;
  };

  return (
    <>
      {showPopup && <div className="backdrop"></div>} {/* Overlay backdrop */}
      <StyledBgContainer className={showPopup ? 'popup-active' : ''}>
        <TopNav />
        <Container maxWidth="sm">
          <Box component="form" noValidate autoComplete="off">
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                px: { sm: 6 },
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  color: 'white',
                  fontFamily: 'Opensans',
                  fontWeight: '700',
                }}
              >
                Connect to your Supervisor{' '}
              </Typography>
              <Typography variant="body2" sx={{ color: 'grey', mt: 1, mb: 3 }}>
                Your Supervisor is the assigned person who has the legal right
                to monitor your activities as governed, defined, or Ordered by
                Rules of Entry or early Release Compliance. This could be a
                Probation Officer, Bondsman, Law Enforcement Officer/Agent, etc.
              </Typography>

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <FormControl
                  fullWidth
                  variant="outlined"
                  sx={{ mb: 1, alignItems: 'center' }}
                >
                  <EmailInput
                    onChange={handleEmail}
                    type="email"
                    value={email}
                    label="Email Address"
                    placeholder="Enter your email"
                  />
                  <Box
                    className="error-msg"
                    sx={{
                      marginTop: '8px',

                      width: '100%',
                    }}
                  >
                    {renderErrorMsg()}
                  </Box>
                </FormControl>

                <Box sx={{ mt: 25 }}>{renderButton()}</Box>
                {showPopup && (
                  <Popup
                    title=<Typography
                      variant="h6"
                      sx={{
                        fontFamily: 'opensans',
                        fontWeight: '700',
                        lineHeight: '1.4',
                      }}
                    >
                      {' '}
                      Profile Created <br /> Successfully{' '}
                    </Typography>
                    message=<Typography variant="body2">
                      {' '}
                      Required information has been saved. Your Supervisor has
                      been sent an email letting them know you have registered
                      and have been added to their private dashboard.
                    </Typography>
                    buttonText="Done"
                    onButtonClick={handleContinue}
                  />
                )}
              </Box>
            </Box>
          </Box>
        </Container>
      </StyledBgContainer>
    </>
  );
};

export default InviteBabysitter;
